module.exports = __webpack_public_path__ + "img/logo-panel.86b807c4.png";